import React from 'react';
import { RmfAppContext } from '../rmf-app';
import { getApiErrorMessage } from '../utils';
import { adminPageClasses, AdminPageContainer } from './page-css';
import { UserListCard } from './user-list-card';

export function UserListPage(): JSX.Element | null {
  const rmfIngress = React.useContext(RmfAppContext);
  const adminApi = rmfIngress?.adminApi;

  if (!adminApi) return null;

  return (
    <AdminPageContainer className={adminPageClasses.pageRoot}>
      <UserListCard
        searchUsers={async (search, limit, offset) => {
          try {
            return (await adminApi.getUsersAdminUsersGet(search, undefined, limit, offset)).data;
          } catch (e) {
            throw new Error(getApiErrorMessage(e));
          }
        }}
        deleteUser={async (user) => {
          try {
            await adminApi.deleteUserAdminUsersUsernameDelete(user);
          } catch (e) {
            throw new Error(getApiErrorMessage(e));
          }
        }}
        createUser={async ({ username, isAdmin, email, phoneNumber, designation, password }) => {
          try {
            await adminApi.createUserAdminUsersPost({
              username,
              is_admin: isAdmin,
              email: email ?? null,
              phone_number: phoneNumber ?? null,
              designation: designation ?? null,
              password,
            });
          } catch (e) {
            throw new Error(getApiErrorMessage(e));
          }
        }}
      />
    </AdminPageContainer>
  );
}
